import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PropertyFactory from "../../Entity/Factories/PropertyFactory";

export default function* propertyList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "properties");

    // Iterate through each raw property data and convert them to objects.
    const properties = res.data.data.map(property => {
      return PropertyFactory.create(property);
    });
    yield put({
      type: Constants.GLOBAL_PROPERTY_LIST_SUCCESS,
      payload: {
        properties: properties
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchPropertyList() {
  yield takeEvery(Constants.GLOBAL_PROPERTY_LIST, propertyList);
}
